import { CancelFastDealItem } from '@spilca/order_ts/v1/order/model_cancel_fast_deal_item_pb';

const cancelFastDealItemConstructor = ({
  id,
  reasonComment,
  description,
  reason
}: Partial<CancelFastDealItem.AsObject>): CancelFastDealItem => {
  const cancel = new CancelFastDealItem();

  if (description) {
    cancel.setDescription(description);
  }
  if (reasonComment) {
    cancel.setReasonComment(reasonComment);
  }
  if (id) {
    cancel.setFastDealItemId(id);
  }
  if (reason) {
    cancel.setReason(reason);
  }

  return cancel;
};

export default cancelFastDealItemConstructor;
